module.exports = __webpack_public_path__ + "img/il.f02035a0.png";